
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinyavatmal() {



const cardData = {
  keyword: 'Cab Service in Yavatmal MIDC',
  heading: 'eTravo: Cab Service in Yavatmal MIDC',
  headingDescription: `eTravo offers dependable and efficient cab services in Yavatmal MIDC, designed to meet the daily transportation needs of industrial workers, corporate employees, and visiting business professionals. Our services ensure smooth and punctual commutes with a fleet of well-maintained, air-conditioned, and GPS-enabled vehicles operated by trained drivers familiar with corporate travel protocols. Whether it’s staff pickup and drop, executive travel, or client transfers, eTravo delivers comfort, safety, and reliability. With flexible booking options, real-time tracking, and 24/7 customer support, businesses in Yavatmal MIDC trust eTravo for seamless and professional cab solutions that support industrial productivity.`,

  top: 'Top Places to visit in Yavatmal with eTravo',
     "topPlaces": [
    {
      "title": "Yavatmal MIDC Industrial Area",
      "description": "Yavatmal's MIDC Industrial Area spans over 205.71 hectares and hosts a variety of industries, including cotton processing, textile manufacturing, and engineering firms. eTravo offers tailored transportation solutions to ensure timely and efficient employee commutes, supporting shift operations and enhancing industrial productivity."
    },
    {
      "title": "Yavatmal City Center",
      "description": "The commercial and administrative heart of Yavatmal, featuring government offices, banks, and corporate establishments. eTravo's executive cab services facilitate seamless travel for business meetings and official engagements, ensuring punctuality and comfort."
    },
    {
      "title": "Yavatmal Railway Station",
      "description": "A crucial railway hub connecting Yavatmal with major cities across India. eTravo offers convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Yavatmal Logistics Hub",
      "description": "An emerging logistics center enhancing the region's warehousing and transportation capabilities. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations and timely deliveries."
    },
    {
      "title": "Amolakchand Mahavidyalaya",
      "description": "A premier educational institution attracting students and faculty from various regions. eTravo offers reliable transportation solutions for daily commutes, academic events, and inter-campus travel, promoting educational excellence."
    },
    {
      "title": "Vasantrao Naik Government Medical College",
      "description": "A key healthcare and educational institution in the region. eTravo provides dependable cab services for medical professionals, students, and patients, ensuring timely arrivals and departures for critical healthcare services."
    },
    {
      "title": "Chintamani Bazaar Complex",
      "description": "A popular shopping destination in Yavatmal, offering a variety of retail outlets and entertainment options. eTravo facilitates transportation for shoppers and retail employees, enhancing the shopping experience with convenient and safe travel options."
    },
    {
      "title": "The Venetian Hotel",
      "description": "A renowned hospitality establishment in Yavatmal. eTravo provides transportation solutions for hotel staff and guests, ensuring seamless travel experiences within the hospitality industry."
    },
    {
      "title": "Government College of Education",
      "description": "An esteemed educational institution offering quality education. eTravo provides transportation solutions for students and faculty members, ensuring safe and timely commutes."
    },
    {
      "title": "Sanjeevan Multispeciality Hospital",
      "description": "A multi-specialty hospital serving the healthcare needs of Yavatmal residents. eTravo offers reliable cab services for healthcare professionals and patients, ensuring timely arrivals and departures from hospitals and clinics."
    }
  ],

services: [
  {
    name: 'Yavatmal MIDC Corporate Cab Rentals',
    description: `Tailored corporate cab rental plans designed to accommodate the diverse transportation needs of businesses in Yavatmal MIDC. Our fleet is regularly serviced and maintained to corporate standards, ensuring seamless, hassle-free rentals for daily commutes, events, or long-term contracts.`
  },
  {
    name: 'Employee Transport Cab Yavatmal MIDC',
    description: `Reliable employee transport service aligned with factory and office shift timings. Equipped with GPS tracking and managed by a dedicated support team, our cabs ensure safe, punctual, and comfortable daily commutes for your workforce, boosting productivity and satisfaction.`
  },
  {
    name: 'Business Cab Services Yavatmal MIDC',
    description: `Flexible and prompt business cab services for executives and staff traveling for meetings, client visits, and site inspections. Our drivers have in-depth local knowledge to navigate efficiently, guaranteeing timely arrivals and a comfortable journey within Yavatmal and nearby areas.`
  },
  {
    name: 'Corporate Staff Cabs Yavatmal MIDC',
    description: `Group transportation solutions using multi-route planning and GPS tracking to provide efficient and cost-effective travel for corporate teams commuting together. This service helps reduce traffic congestion, promote sustainability, and ensures employee safety via batch pickups and drop-offs.`
  },
  {
    name: 'Reliable Corporate Cab Service Yavatmal MIDC',
    description: `Committed to delivering consistently high service quality, featuring clean, well-maintained vehicles and professional drivers. We prioritize punctuality, courteous communication, and customized services tailored to meet the unique requirements of corporate clients in Yavatmal MIDC.`
  },
  {
    name: 'AC Corporate Cabs Yavatmal MIDC',
    description: `Comfort-focused air-conditioned cab services providing a pleasant travel experience throughout the year. Ideal for daily employee commutes and executive rides, our AC fleet ensures cool, relaxing journeys even during the hottest months in Yavatmal.`
  },
  {
    name: 'Staff Pickup and Drop Cab Yavatmal MIDC',
    description: `Comprehensive staff transportation covering multiple shifts, including night duties. With 24/7 availability and flexible scheduling, our experienced drivers guarantee timely pickups and drop-offs, ensuring your workforce travels safely and on schedule at all hours.`
  },
  {
    name: 'Affordable Business Cab Rentals Yavatmal MIDC',
    description: `Cost-effective and transparent pricing plans designed for small, medium, and large enterprises. Our scalable rental options enable businesses to manage transport budgets efficiently while maintaining dependable service and vehicle availability.`
  },
  {
    name: 'Executive Cab Services Yavatmal MIDC',
    description: `Premium executive transportation with luxury vehicles and professional chauffeurs. Perfect for airport transfers, high-profile client visits, and important business meetings, providing discreet, comfortable, and polished travel experiences for VIPs and senior management.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Yavatmal MIDC',
    description: `Fixed-route monthly cab rental packages that simplify employee transport management and reduce administrative burdens. These plans ensure consistent service quality, streamlined billing, and smooth coordination with HR and administrative teams.`
  },
  {
    name: 'Industrial Area Employee Transport Yavatmal MIDC',
    description: `Optimized employee transport solutions tailored for industrial workers, emphasizing safety, punctuality, and regulatory compliance. Our routing and scheduling systems facilitate smooth travel between residential areas and factories in the Yavatmal MIDC industrial zone.`
  },
  {
    name: 'Corporate Client Cabs Yavatmal MIDC',
    description: `Dedicated client transportation services offering professional, comfortable, and punctual travel experiences for visiting business guests. From airport pickups to corporate site visits, we help you make a strong positive impression on clients and partners.`
  },
  {
    name: 'Business Meeting Cabs Yavatmal MIDC',
    description: `Quick-response cab services designed for executives attending urgent or scheduled business meetings within Yavatmal and its vicinity. We provide easy booking options, prompt dispatch, and professional drivers to keep your business operations running smoothly.`
  },
  {
    name: 'Yavatmal Industrial Area Cab Hire',
    description: `Flexible, on-demand cab hire services for site inspections, logistics, and corporate errands across Yavatmal’s industrial corridors. Our knowledgeable drivers ensure efficient, reliable, and hassle-free transportation within the industrial areas.`
  },
  {
    name: 'Corporate Shuttle Cabs Yavatmal MIDC',
    description: `Group shuttle services using minibuses or large vans, ideal for bulk employee movement during shift changes or corporate events. This service improves operational efficiency, reduces environmental impact, and facilitates coordinated team transport.`
  }
],

tableData: [
  ['Yavatmal MIDC Corporate Cab Rentals', 'Employee Transport Cab Yavatmal MIDC'],
  ['Business Cab Services Yavatmal MIDC', 'Corporate Staff Cabs Yavatmal MIDC'],
  ['Reliable Corporate Cab Service Yavatmal MIDC', 'AC Corporate Cabs Yavatmal MIDC'],
  ['Staff Pickup and Drop Cab Yavatmal MIDC', 'Affordable Business Cab Rentals Yavatmal MIDC'],
  ['Executive Cab Services Yavatmal MIDC', 'Monthly Corporate Cab Rentals Yavatmal MIDC'],
  ['Industrial Area Employee Transport Yavatmal MIDC', 'Corporate Client Cabs Yavatmal MIDC'],
  ['Business Meeting Cabs Yavatmal MIDC', 'Yavatmal Industrial Area Cab Hire'],
  ['Corporate Shuttle Cabs Yavatmal MIDC', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Cab Services for Yavatmal MIDC",
    "WhyChoosedescription": "eTravo provides customized cab services designed for businesses in Yavatmal MIDC, ensuring punctual and safe employee transportation to boost operational efficiency and workforce satisfaction."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Our fleet offers sedans, SUVs, and multi-utility vehicles, giving companies flexible options for employee commutes, executive travel, or client visits, all maintained for safety and comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our drivers are professionally trained with detailed knowledge of Yavatmal MIDC’s roads and industrial layout, ensuring smooth navigation and timely pickups."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Match Shift Patterns",
    "WhyChoosedescription": "We provide adaptable booking services including scheduled rides, on-demand cabs, and long-term contracts to accommodate the diverse shift schedules in industrial sectors."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All vehicles are equipped with GPS tracking systems for real-time monitoring, enhancing safety, accountability, and transparency for corporate clients."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We deliver clear, itemized billing statements with trip details and fare breakdowns, making financial management straightforward and transparent."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Standards",
    "WhyChoosedescription": "Our fleet is regularly sanitized and maintained, with drivers following strict hygiene protocols to ensure a clean and safe travel environment."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager who ensures smooth booking management, prompt query resolution, and a seamless cab service experience in Yavatmal MIDC."
  }
]









}

const faqData = [
  [
    {
      question: "Which areas do your Yavatmal MIDC cab services cover?",
      answer: "Our cab services cover the entire Yavatmal MIDC area and nearby industrial sectors, providing reliable transportation for employees."
    },
    {
      question: "Can we schedule rides for different employee shifts?",
      answer: "Yes, we offer flexible scheduling options to cater to fixed, rotating, and night shift requirements."
    },
    {
      question: "Is monthly consolidated billing available for corporate clients?",
      answer: "Absolutely. We provide detailed monthly invoices with comprehensive trip reports to simplify expense management."
    },
    {
      question: "Are your drivers trained in safe and professional driving?",
      answer: "Yes, all our drivers receive training in safe driving, professional etiquette, and are familiar with Yavatmal MIDC routes."
    },
    {
      question: "What safety measures are implemented during rides?",
      answer: "We ensure passenger safety through GPS tracking, vehicle sanitization, driver background verification, and 24/7 support."
    },
    {
      question: "Do corporate clients receive dedicated support?",
      answer: "Yes, corporate clients have access to dedicated account managers and priority customer service."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Sanjay Patil",
    designation: "Plant Manager, Yavatmal Agro Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo has provided us with dependable and timely cab services, improving our employees’ daily commute.”"
  },
  {
    name: "Ms. Meena Wagh",
    designation: "HR Manager, Yavatmal Manufacturing Co.",
    rating: [1, 1, 1, 1, 1],
    text: "“We appreciate the professionalism and responsiveness of eTravo’s team. Their cab service is highly reliable.”"
  }
];








































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Yavatmal MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-yavatmal-midc.jpg",
  "description": "Reliable corporate cab service in Yavatmal MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-yavatmal-midc"
  }
};







    return (
        <div>
<Helmet>
  <title>Cab Service in Yavatmal MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Yavatmal MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/90.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinyavatmal;